import { render, staticRenderFns } from "./ModalDescription.vue?vue&type=template&id=045176a4&"
import script from "./ModalDescription.vue?vue&type=script&lang=js&"
export * from "./ModalDescription.vue?vue&type=script&lang=js&"
import style0 from "./ModalDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports